import { render, staticRenderFns } from "./AnSpin.vue?vue&type=template&id=2c6b6a86&scoped=true&"
import script from "./AnSpin.vue?vue&type=script&lang=js&"
export * from "./AnSpin.vue?vue&type=script&lang=js&"
import style0 from "./AnSpin.vue?vue&type=style&index=0&id=2c6b6a86&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6b6a86",
  null
  
)

export default component.exports